import React, { useState, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import CommonModalWrapper from '../../common-modal-Wrapper/CommonModalWrapper';
import CloseIcon from '../../Icons/CloseIcon';
import AddonExampleCard from '../addon-example-card/AddonExampleCard';
import getFetchConfig from '../../../utils/getFetchConfig';
import handleFetchErrors from '../../../utils/handleFetchErrors';
import LoaderScreen from '../loader-screen/LoaderScreen';
import CheckoutButton from '../../buttons/checkout-button/CheckoutButton';
import { getCurrencySymbol } from '../../../utils/getCurrencySymbol';
import CongratulationsScreen from '../congratulations-screen/CongratulationsScreen';
import Inputs from '../../Inputs/Inputs';
import appURLs from '../../../appURL';
import style from './adsPlans.module.css';
import config from '../../../config';
import { Payment } from '@mui/icons-material';

const formatDateFun = (dateString) => {
  const date = new Date(dateString);
  const month = date.toLocaleString('default', { month: 'short' });
  const day = date.getDate();
  const year = date.getFullYear();
  const formattedDate = `${month} ${day} ${year}`;
  return formattedDate;
}

function addDaysToCurrentDate(days) {
  const currentDate = new Date();
  const newDate = new Date(currentDate.setDate(currentDate.getDate() + days));
  return formatDateFun(newDate);
}

function convertToMonth(days) {
  if (days === 30) return '1';
  else if (days === 90) return '3';
  else return '0';
}

export default function AdsPlansUpdated({ updateSteps, steps, adsId, adsCategoriesId, showAdsPlan, setShowAdsPlan, category, setCongratsClose, congratsClose }) {

  const fetchConfig = getFetchConfig(),
    appURL = appURLs();
  const [feePricing, setFeePricing] = useState({
    isFree: true,
    price: 0,
    currency: "USD",
  });


  const [planData, updatePlanData] = useState([]), //all fetched data from all plans
    [selectedPlanId, setSelectedPlanId] = useState(""),
    [addOnLists, updateAddOnLists] = useState([]),
    [selectedExampleData, updateSelectedExampleData] = useState({}),
    [isModalOpenForExample, toggleExampleModal] = useState(false),
    [selectedPlan, updateSelectedPlan] = useState({}),
    [adExpiry, setAdExpiry] = useState(""),
    [showCongratulations, setShowCongratulations] = useState(false),
    [showLoader, toggleShowLoader] = useState(false),
    [isButtonDisabled, setIsButtonDisabled] = useState(false),
    [showLinkInput, setShowLinkInput] = useState(false),
    [linkToYourWeb, setLinkToYourWeb] = useState(false),
    [addOnsDetails, setAddOnsDetails] = useState([]),
    [totalPrice, setTotalPrice] = useState(0),
    [detailsbox, setDetailsBox] = useState(false),
    [fetchedPriceId, setFetchedPriceId] = useState([]),
    [isLocal, setIsLocal] = useState(false),
    [selectedDuration, setSelectedDuration] = useState({
      adId: "",
      priceId: "",
      duration: 30,
    });
  const [websiteUrl, setWebsiteURL] = useState("");
  const [myads_id, setmyads_id] = useState('');

  const [currency, setCurrency] = useState("USD");
  const [freeAdInfo, setFreeAdInfo] = useState({
    used: 0,
    total: 0,
  });
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("stripe");

  const checkAdFee = async (postId, adsType) => {
    try {
      const response = await fetch(`${appURL}/adfees/fee`, {
        ...fetchConfig,
        method: "POST",
        headers: {
          ...fetchConfig.headers,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ postId, adsType }),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || "Fee check failed");

      return data;
    } catch (err) {
      console.error("Error checking fee:", err);
      toast.error("Unable to fetch ad fee details");
      return null;
    }
  };

  useEffect(() => {
    if (planData && planData.length > 0) {
      const initialPlan = planData[0]; // Get the first plan if available
      let priceId = ""; // Default value for priceId

      // Assign priceId based on the duration
      switch (initialPlan.duration) {
        case 30:
          priceId = "64e4db3ef9eeb14b6e2185c8"; // 30 days
          break;
        case 90:
          priceId = "64e4db08f9eeb14b6e2185c4"; // 90 days
          break;
        case 0:
          priceId = "64e4da83f9eeb14b6e2185bc"; // permanent
          break;
        default:
          priceId = ""; // Default case if duration doesn't match
      }

      setSelectedDuration({
        adId: initialPlan._id,
        priceId: priceId,
        duration: initialPlan.duration,
      });
    }
  }, [planData]);

  useEffect(() => {
    if (isLocal && planData.length > 0) {
      setSelectedDuration({
        adId: planData[planData.length - 1]._id,
        priceId: "64e4da83f9eeb14b6e2185bc",
        duration: planData[planData.length - 1].duration,
      })
    }
  }, [isLocal, planData])

  const isLocalValue = localStorage.getItem("adsCategories"); // Retrieve the value directly
  const editAdId = localStorage.getItem("new_my_id")

  // useEffect(() => {
  //   if (isLocalValue.includes("Local")) {
  //     setIsLocal(true);
  //   }
  // }, [isLocalValue]); // Add isLocalValue as a dependency
  useEffect(() => {
    if (isLocalValue && isLocalValue.includes("Local")) {
      setIsLocal(true);
    }
  }, [isLocalValue]);



  // useEffect(() => {
  //   const postId = adsId || editAdId;
  //   if (postId && adsCategoriesId) {
  //     toggleShowLoader(true);

  //     checkAdFee(postId, adsCategoriesId)
  //       .then((feeData) => {
  //         if (feeData?.adFee?.fees) {
  //           const { price, currency } = feeData.adFee.fees;
  //           const freeCount = feeData.adFee?.freeCount || 0;
  //           const userUsed = feeData?.userAdsCount || 0;
  //           const createdAt = feeData.adFee?.createdAt;
  //           console.log("Fee Data:", feeData);
  //           // setTotalPrice(price || 0);
  //           setTotalPrice(Number(price) || 0);
  //           setCurrency(currency || "USD");

  //           // Set Free Ad Info dynamically
  //           setFreeAdInfo({
  //             used: userUsed,
  //             total: freeCount,
  //           });

  //           if (price === 0 || freeCount > 0) {
  //             setAdExpiry("Free until quota reached");
  //           } else if (createdAt) {
  //             const expiryDate = new Date(createdAt);
  //             expiryDate.setDate(expiryDate.getDate() + 30);
  //             setAdExpiry(
  //               expiryDate.toLocaleDateString("en-US", {
  //                 day: "2-digit",
  //                 month: "long",
  //                 year: "numeric",
  //               })
  //             );
  //           }
  //         } else {
  //           setTotalPrice(0);
  //           setAdExpiry("No fee data");
  //           setFreeAdInfo({ used: 0, total: 0 });
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Error fetching ad fee:", err);
  //         toast.error("Unable to fetch ad fee details");
  //         setTotalPrice(0);
  //         setAdExpiry("Error fetching fee");
  //         setFreeAdInfo({ used: 0, total: 0 });
  //       })
  //       .finally(() => toggleShowLoader(false));
  //   }
  // }, [adsId, editAdId, adsCategoriesId]);

  useEffect(() => {
    const postId = adsId || editAdId;

    const runApisInOrder = async () => {

      if (!postId || !adsCategoriesId) return;

      toggleShowLoader(true);
      try {
        // 1. First call fetch plan API
        await fetchPlanData();

        // 2. Then call fee API
        const feeData = await checkAdFee(postId, adsCategoriesId);
        const usedAds = feeData?.userAdsCount ?? 0;
        const freeAds = feeData?.adFee?.freeCount ?? 0;

        const price = feeData?.adFee?.fees?.price ?? 0;
        const currency = feeData?.adFee?.fees?.currency ?? "USD";

        const isFreeByFee = usedAds < freeAds;

        setFeePricing({
          isFree: isFreeByFee,
          price,
          currency,
        });


        if (feeData?.adFee?.fees) {
          const { price, currency } = feeData.adFee.fees;
          const freeCount = feeData.adFee?.freeCount || 0;
          const userUsed = feeData?.userAdsCount || 0;
          const createdAt = feeData.adFee?.createdAt;

          setTotalPrice(feeData.payment == false ? 0 : Number(price));
          setDetailsBox(freeCount > 0 ? true : false)
          setCurrency(currency || "USD");
          setFreeAdInfo({ used: userUsed, total: freeCount });

          if (price === 0 || freeCount > 0) {
            setAdExpiry("Free until quota reached");
          } else if (createdAt) {
            const expiryDate = new Date(createdAt);
            expiryDate.setDate(expiryDate.getDate() + 30);
            setAdExpiry(
              expiryDate.toLocaleDateString("en-US", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            );
          }
        } else {
          setTotalPrice(0);
          setAdExpiry("No fee data");
          setFreeAdInfo({ used: 0, total: 0 });
        }
      } catch (err) {
        console.error("Error in ads flow:", err);
        toast.error("Unable to fetch plan or fee data");
        setTotalPrice(0);
        setAdExpiry("Error fetching data");
        setFreeAdInfo({ used: 0, total: 0 });
      } finally {
        toggleShowLoader(false);
      }
    };

    runApisInOrder();
  }, [adsId, editAdId, adsCategoriesId]);


  const fetchPlanData = () => {
    toggleShowLoader(true);

    fetch(`${appURL}/posts/ads/fetch_plan?ads_type=${adsCategoriesId}`, {
      ...fetchConfig,
      method: "GET",
    })
      .then(handleFetchErrors)
      .then((res) => {
        toggleShowLoader(false);

        if (res.status === 200 && res?.data?.length) {
          const adsPlansData = res.data[0]; // Ensure adsPlansData is assigned correctly

          if (adsPlansData?.add_ons?.length) {
            // Filter add-ons with the name "Link to your website"
            const filteredAddOns = adsPlansData.add_ons.filter(
              (addon) => addon.name === "Link to your website"
            );

            // Update state if there are filtered add-ons
            if (filteredAddOns.length) {
              updateSelectedPlan(filteredAddOns[0]); // Corrected function name
              updatePlanData(res.data);
            }
          }
        } else {
          toast.error("Something went wrong"); // Ensure meaningful error feedback
        }
      })
      .catch((err) => {
        toggleShowLoader(false);
        console.error("Error fetching plan data:", err); // Log error for debugging
        toast.error("Failed to fetch plan data. Please try again.");
      });
  };

  const backBtnClickHandler = () => {
    updateSteps(steps - 1)
  }



  function calculateDuration(days) {
    const daysInMonth = 30;
    const daysInWeek = 7;
    const months = Math.floor(days / daysInMonth);
    const remainingDays = days % daysInMonth;
    const weeks = Math.floor(remainingDays / daysInWeek);
    const remainingDaysInWeek = remainingDays % daysInWeek;

    if (months !== 0 && weeks !== 0 && remainingDaysInWeek !== 0) {
      return `${months * daysInMonth + weeks * daysInWeek + remainingDaysInWeek} days`;
    } else if (months !== 0 && weeks !== 0) {
      return `${months * daysInMonth + weeks * daysInWeek} days`;

    } else if (months !== 0) {
      const monthValue = months === 1 ? "month" : "months";
      return `${months} ${monthValue}`;
    } else if (weeks !== 0 && remainingDaysInWeek !== 0) {
      return `${weeks * daysInWeek + remainingDaysInWeek} days`;
    } else if (weeks !== 0) {
      const weeksValue = weeks === 1 ? "week" : "weeks";
      return `${weeks} ${weeksValue}`;
    } else {
      return `${remainingDaysInWeek} days`;
    }
  }

  const planRadioBtnOption = useMemo(() => {
    return planData.map(plan => ({
      label: calculateDuration(plan?.duration) !== '0 days' ? calculateDuration(plan?.duration) : 'Permanent',
      value: String(plan?._id), // Ensure the _id is used as the value for the radio button
    }));
  }, [planData]);
  useEffect(() => {
    if (adExpiry === "lifetime") {
      setAdExpiry("lifetime");
    } else {
      const date = new Date(adExpiry);
      const formattedDate = date.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
      setAdExpiry(formattedDate);
    }
  }, [adExpiry]);


  useEffect(() => {
    fetchPlanData()
  }, [myads_id, adsCategoriesId])

  const handleExampleModal = () => {
    updateSelectedExampleData({
      title: selectedPlan?.example_title,
      description: selectedPlan?.example_description,
      image: selectedPlan?.example_image
    })
    toggleExampleModal(true);
  }

  const dateFormat = 'DD/MM/YYYY';
  const startDate = localStorage.getItem('start_date');
  const endDate = localStorage.getItem('end_date');

  const start = dayjs(startDate, dateFormat).toDate();
  const end = dayjs(endDate, dateFormat).toDate();
  const dateDiff = Math.floor((end - start) / (1000 * 60 * 60 * 24));

  let expirationDate;

  if (dateDiff > 30) {
    expirationDate = end.toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  } else {
    const expirationDay = end.getDate() + 1;
    const expirationMonth = end.getMonth() + 1;
    const expirationYear = end.getFullYear();
    expirationDate = new Date(expirationYear, expirationMonth - 1, expirationDay).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }


  const updatedFetchConfig = fetchConfig;
  updatedFetchConfig.headers['Content-Type'] = 'application/json';



  const handleSubmission = () => {
    toggleShowLoader(true);
    try {
      // Validate inputs
      if (linkToYourWeb && !websiteUrl) {
        toggleShowLoader(false);
        return toast.error("Please provide website link");
      }

      // Construct the payload
      const payload = {
        postId: adsId || editAdId,
        planId: selectedDuration.adId,
        add_ons: linkToYourWeb ? [selectedPlan?.price[0]?._id] : [],
        ...(websiteUrl && { website_url: websiteUrl }),
        isPromoted: false,
        paymentMethod: selectedPaymentMethod,
        // redirect_uri_success: "http://localhost:3005/success",
        redirect_uri_success: "https://test.menehariya.com/success",
      };

      fetch(`${appURL}/posts/payment/create-payment-intent`, {
        ...updatedFetchConfig,
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then(async (response) => {
          toggleShowLoader(false);

          // Check if response is a redirect
          if (response.redirected) {
            // Follow the redirect
            window.location.href = response.url;
            return;
          }

          // Try to parse as JSON only if it's not a redirect
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            const res = await response.json();

            if (res.paymentIntent) {
              // Open checkout page
              window.location.href = res.paymentIntent;
            } else if (response.status === 201) {
              // Successfully posted without payment
              updateSteps(steps + 1);
            }
          } else {
            // If it's not JSON, it might be HTML - follow redirect
            window.location.href = response.url;
          }
        })
        .catch((err) => {
          console.error("Error during submission:", err);
          toggleShowLoader(false);
          toast.error("Something went wrong. Please try again.");
        });
    } catch (err) {
      console.error("Unexpected error:", err);
      toggleShowLoader(false);
      toast.error("Something went wrong. Please try again.");
    }
  };
  // const handleSubmission = () => {
  //   toggleShowLoader(true);
  //   try {
  //     // Validate inputs
  //     if (linkToYourWeb && !websiteUrl) {
  //       toggleShowLoader(false);
  //       return toast.error("Please provide website link");
  //     }

  //     // Construct the payload
  //     const payload = {
  //       postId: adsId || editAdId, //edit api hit id 
  //       // planId: selectedPlan.plan_id,
  //       planId: selectedDuration.adId, //
  //       // add_ons: linkToYourWeb ? [selectedDuration.priceId] : [], // Month ID linked to your website
  //       add_ons: linkToYourWeb ? [selectedPlan?.price[0]?._id] : [],
  //       // price_drop: 0,
  //       ...(websiteUrl && { website_url: websiteUrl }), // Include websiteUrl only if not empty
  //       isPromoted: false,
  //       paymentMethod: selectedPaymentMethod,
  //       redirect_uri_success: "http://localhost:3005/success",
  //       // redirect_uri_success: `${config.appUrl}/success`,
  //       // redirect_uri_cancel:`${config.appUrl}/canel`,
  //       // redirect_uri_failure:`${config.appUrl}/cancel`

  //       //redirect_uri_success: "https://menehariya.netscapelabs.com/success",
  //     };

  //     fetch(`${appURL}/posts/payment/create-payment-intent`, {
  //       ...updatedFetchConfig,
  //       body: JSON.stringify(payload),
  //     })
  //       .then(handleFetchErrors)
  //       .then((res) => {
  //         toggleShowLoader(false);

  //         if (res.paymentIntent) {
  //           // Open checkout page
  //           window.location.href = res.paymentIntent;
  //         } else if (res.status === 201) {
  //           // Successfully posted without payment
  //           updateSteps(steps + 1);
  //         }
  //       })

  //       //   // Handle the response
  //       //     if (res.status === 201) {
  //       //       // setShowCongratulations(true);
  //       //       // setCongratsClose(true);
  //       //       updateSteps(steps + 1);  
  //       //   } else if (res.paymentIntent !== null) {
  //       //     window.location.href = res.paymentIntent;
  //       //   }
  //       // })

  //       // Handle the response
  //       //   if (res.status === 201) {
  //       //     // setShowCongratulations(true);
  //       //     // setCongratsClose(true);
  //       //    if (res.paymentIntent !== null) {
  //       //     window.location.href = res.paymentIntent;
  //       //   }else{
  //       //     updateSteps(steps + 1);
  //       //   }}
  //       // })
  //       .catch((err) => {
  //         console.error("Error during submission:", err);
  //         toggleShowLoader(false);
  //         toast.error("Something went wrong. Please try again.");
  //       });
  //   } catch (err) {
  //     console.error("Unexpected error:", err);
  //     toggleShowLoader(false);
  //     toast.error("Something went wrong. Please try again.");
  //   }
  // };

  if (showLoader) {
    return <LoaderScreen />
  }

  // Plan change handler
  const planChangeHandler = (event) => {
    const selectedPlanId = event.target.value; // Get the value of the selected radio button

    // Find the selected plan from planData based on the selected plan ID
    const selectedPlan = planData.find(plan => plan._id === selectedPlanId);

    if (selectedPlan) {
      let priceId = ""; // Default value for priceId

      // Assign priceId based on the duration
      switch (selectedPlan.duration) {
        case 30:
          priceId = "64e4db3ef9eeb14b6e2185c8"; // 30 days
          break;
        case 90:
          priceId = "64e4db08f9eeb14b6e2185c4"; // 90 days
          break;
        case 0:
          priceId = "64e4da83f9eeb14b6e2185bc"; // 0 days
          break;
        default:
          priceId = ""; // Default case if duration doesn't match
      }

      setSelectedDuration({
        adId: selectedPlan._id,
        priceId: priceId,
        duration: selectedPlan.duration,
      });
    }
  };


  return (
    <>
      <div className='ad-page-main'>

        {showCongratulations &&
          <CongratulationsScreen adsId={myads_id} />
        }

        <CommonModalWrapper isOpen={isModalOpenForExample} className={style.example_modal} >
          <CloseIcon onClick={() => toggleExampleModal(false)} />
          <AddonExampleCard selectedExampleData={selectedExampleData} handleExampleModal={handleExampleModal} />
        </CommonModalWrapper>

        <section id='span-2' className={style.ads_plan_wrapper} >
          {/* if Not Local Biz Promotion */}
          {!isLocal && (
            <>

              <section className={style.expire_text_section}>
                {
                  planRadioBtnOption.length === 1 && !selectedPlan?.price[0]?.isfree && (
                    <span className={style.ads_expire_info_text}>
                      This Ad will expire on {planData[0]?.duration ? addDaysToCurrentDate(planData[0]?.duration) : ''}
                    </span>)}
              </section>
            </>
          )}

          {/* if Local Biz Promotion */}
          {isLocal && (
            <>
              {/* <h5 style={{ textAlign: 'center', fontWeight: 'bold' }}>Buy Promotions</h5> */}
              {/* 
              <section id={planRadioBtnOption.length === 1 && style.expire_text_section} className={style.expire_text_section}>
                {
                  planRadioBtnOption.length > 0 &&
                  // <Inputs
                  //   name='careType'
                  //   value={selectedDuration.adId}
                  //   onChangeHandler={planChangeHandler}
                  //   type='radio'
                  //   id='span-2'
                  //   required={true}
                  //   radioBtnOtions={planRadioBtnOption.slice(2)}
                  // />
                   <label className={style.permanent_radio}>
                                    <input
                                      type="radio"
                                      name="careType"
                                      checked
                                      readOnly
                                    />
                                    <span className={style.custom_radio}></span>
                                    <span className={style.permanent_text}>Permanent</span>
                                  </label>
                }

                <div className={style.price_section}>
                  <span className={style.plan_price_text}>
                    Free
                  </span>

                   <p className={style.expire_text}>
                          {planData?.name === "Local Biz & Services" && adExpiry === "lifetime"
                            ? "This ad won't expire"
                            : `This Ad will expire on ${adExpiry}`
                          }
                        </p>

                </div>
              </section> */}
              <section className={style.expire_text_section}>
                <label className={style.permanent_radio}>
                  <input type="radio" checked readOnly />
                  <span className={style.custom_radio}></span>
                  <span className={style.permanent_text}>Permanent</span>
                </label>

                <div className={style.price_section}>
                  {/* <span className={style.plan_price_text}>
                    {feePricing.isFree
                      ? "Free"
                      : `${getCurrencySymbol(feePricing.currency)}${feePricing.price}`}
                  </span> */}
                  <span className={style.plan_price_text}>
                    {feePricing.isFree || Number(feePricing.price) === 0
                      ? "Free"
                      : `${getCurrencySymbol(feePricing.currency)}${feePricing.price}`}
                  </span>


                  <p className={style.expire_text}>
                    {feePricing.isFree
                      ? "This ad won't expire"
                      : "This ad won't expire"}
                  </p>
                </div>

              </section>
            </>
          )}

          {/* free ads / paid ads */}
          {detailsbox > 0 && (
            <div
              className="ad-fee-container"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0px",
                marginTop: "20px",
              }}
            >

              {/* Free Ads Box */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  backgroundColor: "#fff",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  marginBottom: "12px",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span
                    style={{
                      backgroundColor: "#059669",
                      color: "#fff",
                      padding: "6px 12px",
                      borderRadius: "8px",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    Free Ad
                  </span>

                  <span
                    style={{
                      border: "1px solid #059669",
                      color: "#065f46",
                      padding: "6px 12px",
                      borderRadius: "8px",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    {Math.min(freeAdInfo.used, freeAdInfo.total)}/{freeAdInfo.total}
                  </span>
                </div>

                {/* Progress Bar */}
                <div
                  style={{
                    width: "100%",
                    height: "8px",
                    borderRadius: "6px",
                    backgroundColor: "#e5e7eb",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      borderRadius: "6px",
                      width: `${Math.min((freeAdInfo.used / freeAdInfo.total) * 100, 100)}%`,
                      backgroundColor: freeAdInfo.used >= freeAdInfo.total ? "#dc2626" : "#10b981",
                      transition: "width 0.3s ease",
                    }}
                  />
                </div>

                {/* Remaining / Exhausted Message */}
                <p
                  style={{
                    marginTop: "4px",
                    fontSize: "13px",
                    fontWeight: "500",
                    color: freeAdInfo.used >= freeAdInfo.total ? "#dc2626" : "#059669",
                  }}
                >
                  {freeAdInfo.used >= freeAdInfo.total
                    ? "You have no free ads left"
                    : `${Math.max(freeAdInfo.total - freeAdInfo.used, 0)} free ads remaining`}
                </p>
              </div>

              {/* Paid Ads Box */}
              {/* <div
              className="ad-fee-box"
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#fff",
                borderRadius: "10px",
                padding: "10px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              {totalPrice > 0 && (
                <hr style={{ margin: "12px 0", border: "0.5px solid #eee" }} />
              )}

              {totalPrice > 0 && (
                <>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div
                      style={{
                        backgroundColor: "#ef6c00",
                        color: "#fff",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        fontWeight: "bold",
                      }}
                    >
                      Paid Ad
                    </div>

                    <div
                      style={{
                        border: "1px solid #ef6c00",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        fontWeight: "bold",
                        color: "#ef6c00",
                      }}
                    >
                      ${totalPrice} {currency}
                    </div>
                  </div>
                </>
              )}
            </div> */}

            </div>
          )}


          <section className={style.addon_section_wrapper}>
            <section className={style.sub_heading_and_selectall_wrapper}>
              <h4>Make your ad stand out!</h4>
              <div className={style.sub_heading_and_selectall_section}>
                <span>Select an option to promote your ad</span>
              </div>
            </section>

            <section className={style.plan_card_wrapper} key={selectedPlan?._id}>
              <div className={style.check_plan_heading_wrapper}>
                <div
                  className={style.check_box_wrapper}
                  onClick={() => handleExampleModal()}
                  style={{ cursor: "pointer" }}
                >
                  <input
                    type="checkbox"
                    className={style.plans_checkbox}
                    checked={linkToYourWeb}
                    onChange={() => (setLinkToYourWeb(!linkToYourWeb), toggleExampleModal(false))}
                    style={{
                      display: "block",
                      appearance: "checkbox",
                      width: "20px",
                      height: "20px",
                      border: "2px solid orange",
                      marginRight: "5px",
                    }}
                  />

                  <p
                    style={{
                      backgroundColor: selectedPlan?.name === "Link to your website" ? "blue" : "inherit",
                    }}
                    className={style.plan_heading_text}
                  >
                    {selectedPlan?.name}
                  </p>
                </div>

                <p className={style.plan_description_text}>
                  {selectedPlan?.description}{" "}
                  <span
                    onClick={() => handleExampleModal()}
                    className={style.view_example_text}
                  >
                    View example
                  </span>
                </p>

                {linkToYourWeb ? <input
                  value={websiteUrl}
                  onChange={(e) => setWebsiteURL(e.target.value)}
                  type="text"
                  name="website"
                  className={style.website_text_input_field}
                  placeholder="Enter website link"
                /> : ""}

              </div>

              <select
                id={style.select_plan_input}
                className={
                  linkToYourWeb
                    ? `${style.select_plan_input} ${style.active_card}`
                    : style.select_plan_input
                }
              // onChange={(e) => handlePlanChange(e.target.value, selectedPlan?._id)}
              >
                <option value="Free">Free</option>
              </select>
            </section>


            {/* Select payment method */}
            {/* {totalPrice > 0 && (
<section className={style.payment_method_wrapper}>
  <h4 style={{ marginBottom: "6px", marginTop: '30px', fontWeight: "600", fontSize: "14px" }}>
    Choose Payment Method
  </h4>

  <div style={{ display: "flex", gap: "12px" }}>
 
    <div
      onClick={() => setSelectedPaymentMethod("stripe")}
      style={{
        flex: 1,
        border: selectedPaymentMethod === "stripe" ? "2px solid #10b981" : "1px solid #ccc",
        borderRadius: "6px",
        padding: "6px 8px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        backgroundColor: selectedPaymentMethod === "stripe" ? "#f0fdf4" : "#fff",
        transition: "all 0.2s ease",
        fontSize: "13px"
      }}
    >
      <input
        type="radio"
        name="paymentMethod"
        value="stripe"
        checked={selectedPaymentMethod === "stripe"}
        onChange={() => setSelectedPaymentMethod("stripe")}
        style={{ cursor: "pointer", width: "14px", height: "14px" }}
      />
      <img
        src="/images/stripe.png" 
        alt="Stripe"
        style={{ width: "70px", height: "50px" }}
      />
      <span style={{ fontWeight: "500" }}>Stripe</span>
    </div>

   
    <div
      onClick={() => setSelectedPaymentMethod("santimpay")}
      style={{
        flex: 1,
        border: selectedPaymentMethod === "santimpay" ? "2px solid #10b981" : "1px solid #ccc",
        borderRadius: "6px",
        padding: "6px 8px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        backgroundColor: selectedPaymentMethod === "santimpay" ? "#f0fdf4" : "#fff",
        transition: "all 0.2s ease",
        fontSize: "13px"
      }}
    >
      <input
        type="radio"
        name="paymentMethod"
        value="santimpay"
        checked={selectedPaymentMethod === "santimpay"}
        onChange={() => setSelectedPaymentMethod("santimpay")}
        style={{ cursor: "pointer", width: "14px", height: "14px" }}
      />
      <img
        src="/images/santimpay.png" 
        alt="Santimpay"
        style={{ width: "80px", height: "40px" }}
      />
      <span style={{ fontWeight: "500" }}>Santimpay</span>
    </div>
  </div>
</section>
  )} */}




            <CheckoutButton
              cancelButtonText="Back"
              // submitBtnText={`Post My Ad`}
              submitBtnText={
                totalPrice ?
                  `Post My Ad • $${totalPrice} ${currency}`
                  :
                  `Post My Ad`
              }
              id="span-2"
              backBtnClickHandler={backBtnClickHandler}
              onClickHandler={handleSubmission}
              showLoader={showAdsPlan}
              disabled={isButtonDisabled}
              showAdsPlan={showAdsPlan}
            />

          </section>
        </section>
      </div>
    </>
  )
}
